{
  "file": {
    "filename": "irs.xls",
    "url": "https://www.irs.gov/pub/irs-soi/23sp02is.xls",
    "sha256": "fcc458d3e759a89ef90d3b6e4c8e512dccfe16f03d44f8aa2246bd2d412f5978"
  },
  "publicationMonth": "2026-03",
  "taxYear": 2023,
  "moneyUnit": "Thousands of USD",
  "industries": [
    {
      "id": "industry-1",
      "name": "All nonfarm industries",
      "values": {
        "returns": {
          "value": 31125909,
          "cell": "B12"
        },
        "receipts": {
          "value": 2063191945,
          "cell": "B13"
        },
        "deductions": {
          "value": 1687308383,
          "cell": "B16"
        },
        "advertising": {
          "value": 24294438,
          "cell": "B24"
        },
        "contractLabor": {
          "value": 113575079,
          "cell": "B27"
        },
        "wages": {
          "value": 121796125,
          "cell": "B42"
        },
        "netIncome": {
          "value": 377210993,
          "cell": "B48"
        }
      }
    },
    {
      "id": "industry-63",
      "name": "Information",
      "values": {
        "returns": {
          "value": 474628,
          "cell": "BL12"
        },
        "receipts": {
          "value": 16621647,
          "cell": "BL13"
        },
        "deductions": {
          "value": 12675426,
          "cell": "BL16"
        },
        "advertising": {
          "value": 542663,
          "cell": "BL24"
        },
        "contractLabor": {
          "value": 1105611,
          "cell": "BL27"
        },
        "wages": {
          "value": 802871,
          "cell": "BL42"
        },
        "netIncome": {
          "value": 4095534,
          "cell": "BL48"
        }
      }
    },
    {
      "id": "industry-96",
      "name": "Professional, scientific, and technical services",
      "values": {
        "returns": {
          "value": 3912417,
          "cell": "CS12"
        },
        "receipts": {
          "value": 250227539,
          "cell": "CS13"
        },
        "deductions": {
          "value": 151043747,
          "cell": "CS16"
        },
        "advertising": {
          "value": 4156983,
          "cell": "CS24"
        },
        "contractLabor": {
          "value": 11649909,
          "cell": "CS27"
        },
        "wages": {
          "value": 15340538,
          "cell": "CS42"
        },
        "netIncome": {
          "value": 99328388,
          "cell": "CS48"
        }
      }
    },
    {
      "id": "industry-97",
      "name": "Legal services",
      "values": {
        "returns": {
          "value": 316370,
          "cell": "CT12"
        },
        "receipts": {
          "value": 43229954,
          "cell": "CT13"
        },
        "deductions": {
          "value": 24302244,
          "cell": "CT16"
        },
        "advertising": {
          "value": 809885,
          "cell": "CT24"
        },
        "contractLabor": {
          "value": 1356972,
          "cell": "CT27"
        },
        "wages": {
          "value": 4186714,
          "cell": "CT42"
        },
        "netIncome": {
          "value": 18921033,
          "cell": "CT48"
        }
      }
    },
    {
      "id": "industry-98",
      "name": "Offices of certified public accountants",
      "values": {
        "returns": {
          "value": 28476,
          "cell": "CU12"
        },
        "receipts": {
          "value": 4181407,
          "cell": "CU13"
        },
        "deductions": {
          "value": 2308447,
          "cell": "CU16"
        },
        "advertising": {
          "value": 44906,
          "cell": "CU24"
        },
        "contractLabor": {
          "value": 107669,
          "cell": "CU27"
        },
        "wages": {
          "value": 698351,
          "cell": "CU42"
        },
        "netIncome": {
          "value": 1872959,
          "cell": "CU48"
        }
      }
    },
    {
      "id": "industry-99",
      "name": "Other accounting services",
      "values": {
        "returns": {
          "value": 333080,
          "cell": "CV12"
        },
        "receipts": {
          "value": 11707891,
          "cell": "CV13"
        },
        "deductions": {
          "value": 7137974,
          "cell": "CV16"
        },
        "advertising": {
          "value": 209079,
          "cell": "CV24"
        },
        "contractLabor": {
          "value": 468650,
          "cell": "CV27"
        },
        "wages": {
          "value": 790691,
          "cell": "CV42"
        },
        "netIncome": {
          "value": 4595590,
          "cell": "CV48"
        }
      }
    },
    {
      "id": "industry-106",
      "name": "Specialized design services",
      "values": {
        "returns": {
          "value": 306934,
          "cell": "DC12"
        },
        "receipts": {
          "value": 14332404,
          "cell": "DC13"
        },
        "deductions": {
          "value": 9990938,
          "cell": "DC16"
        },
        "advertising": {
          "value": 252687,
          "cell": "DC24"
        },
        "contractLabor": {
          "value": 545554,
          "cell": "DC27"
        },
        "wages": {
          "value": 331795,
          "cell": "DC42"
        },
        "netIncome": {
          "value": 4340075,
          "cell": "DC48"
        }
      }
    },
    {
      "id": "industry-107",
      "name": "Computer systems design services",
      "values": {
        "returns": {
          "value": 318183,
          "cell": "DD12"
        },
        "receipts": {
          "value": 16799666,
          "cell": "DD13"
        },
        "deductions": {
          "value": 10570563,
          "cell": "DD16"
        },
        "advertising": {
          "value": 287071,
          "cell": "DD24"
        },
        "contractLabor": {
          "value": 1260771,
          "cell": "DD27"
        },
        "wages": {
          "value": 1074548,
          "cell": "DD42"
        },
        "netIncome": {
          "value": 6220488,
          "cell": "DD48"
        }
      }
    },
    {
      "id": "industry-109",
      "name": "Management, scientific, and technical consulting services",
      "values": {
        "returns": {
          "value": 1109907,
          "cell": "DF12"
        },
        "receipts": {
          "value": 67087060,
          "cell": "DF13"
        },
        "deductions": {
          "value": 33480600,
          "cell": "DF16"
        },
        "advertising": {
          "value": 1086100,
          "cell": "DF24"
        },
        "contractLabor": {
          "value": 3465885,
          "cell": "DF27"
        },
        "wages": {
          "value": 2524765,
          "cell": "DF42"
        },
        "netIncome": {
          "value": 33709178,
          "cell": "DF48"
        }
      }
    },
    {
      "id": "industry-110",
      "name": "Scientific research and development services",
      "values": {
        "returns": {
          "value": 64361,
          "cell": "DG12"
        },
        "receipts": {
          "value": 1906442,
          "cell": "DG13"
        },
        "deductions": {
          "value": 1223002,
          "cell": "DG16"
        },
        "advertising": {
          "value": 5916,
          "cell": "DG24"
        },
        "contractLabor": {
          "value": 70439,
          "cell": "DG27"
        },
        "wages": {
          "value": 133132,
          "cell": "DG42"
        },
        "netIncome": {
          "value": 702511,
          "cell": "DG48"
        }
      }
    },
    {
      "id": "industry-111",
      "name": "Advertising and related services",
      "values": {
        "returns": {
          "value": 179434,
          "cell": "DH12"
        },
        "receipts": {
          "value": 13628176,
          "cell": "DH13"
        },
        "deductions": {
          "value": 9905935,
          "cell": "DH16"
        },
        "advertising": {
          "value": 492418,
          "cell": "DH24"
        },
        "contractLabor": {
          "value": 718446,
          "cell": "DH27"
        },
        "wages": {
          "value": 690545,
          "cell": "DH42"
        },
        "netIncome": {
          "value": 3732166,
          "cell": "DH48"
        }
      }
    },
    {
      "id": "industry-118",
      "name": "Educational services",
      "values": {
        "returns": {
          "value": 862502,
          "cell": "DO12"
        },
        "receipts": {
          "value": 16807961,
          "cell": "DO13"
        },
        "deductions": {
          "value": 11896058,
          "cell": "DO16"
        },
        "advertising": {
          "value": 294992,
          "cell": "DO24"
        },
        "contractLabor": {
          "value": 812925,
          "cell": "DO27"
        },
        "wages": {
          "value": 980542,
          "cell": "DO42"
        },
        "netIncome": {
          "value": 4942946,
          "cell": "DO48"
        }
      }
    }
  ]
}
